export default __webpack_public_path__ + "static/ben-stevenson-91b24c7632b7be9c2243b45fd647d2bf.jpg";